import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, ChevronRight } from 'lucide-react';

const OpinionServiceDashboard = () => {
  const navigate = useNavigate();

  // Check if authenticated
  useEffect(() => {
    const authenticated = sessionStorage.getItem('opinionServiceAuthenticated');
    if (!authenticated) {
      navigate('/opinion-service-login');
    }
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem('opinionServiceAuthenticated');
    localStorage.removeItem('token');
    navigate('/opinion-service-login');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      {/* Header */}
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">🎯 Opinion Services</h1>
            <p className="text-gray-600 text-sm mt-1">Survey & feedback collection platform</p>
          </div>
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
          >
            <LogOut size={18} />
            Logout
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {/* Card 1 - Agents */}
          <button
            onClick={() => navigate('/opinion-scripts')}
            className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition text-left"
          >
            <div className="text-4xl mb-4">🤖</div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Agents</h3>
            <p className="text-gray-600 text-sm">Create and manage opinion survey agents</p>
            <div className="mt-4 flex items-center gap-2 text-blue-600 font-medium">
              Open <ChevronRight size={18} />
            </div>
          </button>

          {/* Card 2 - Logs */}
          <button
            onClick={() => navigate('/opinion-logs')}
            className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition text-left"
          >
            <div className="text-4xl mb-4">📊</div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Logs</h3>
            <p className="text-gray-600 text-sm">View survey responses and results</p>
            <div className="mt-4 flex items-center gap-2 text-blue-600 font-medium">
              View <ChevronRight size={18} />
            </div>
          </button>

          {/* Card 3 - Contacts */}
          <button
            onClick={() => navigate('/opinion-contacts')}
            className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition text-left"
          >
            <div className="text-4xl mb-4">📇</div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Import Contacts</h3>
            <p className="text-gray-600 text-sm">Upload and manage contacts for calling campaigns</p>
            <div className="mt-4 flex items-center gap-2 text-blue-600 font-medium">
              Open <ChevronRight size={18} />
            </div>
          </button>
        </div>

        {/* Recent Activity */}
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Recent Activity</h2>
          <div className="text-gray-600 text-center py-8">
            <p>No surveys yet. Create your first survey to get started.</p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default OpinionServiceDashboard;
